import styled from "styled-components";

export const NextLink = styled.div`
  height: max-content;
  width: max-content;
  background: none;
  cursor: pointer;
`;
